import { markRaw } from "vue";
import StDelete from "@/components/common/Delete.vue";
import { useUser } from "@/composables/useUser";
import { useTable } from "./useTable";

export const useAccountTravellerTable = () => {
  const user = useUser();
  const table = useTable((traveller) => ({
    phoneNumber: traveller.phoneNumber,
    cardNumber: traveller.cardNumber,
    name: traveller.name,
    subscription: traveller.subscription ? "Ja" : "Nej",
    inAppPurchases: traveller.inAppPurchases ? "Ja" : "Nej",
    delete: {
      component: markRaw(StDelete),
      componentProps: { disabled: !user.state.isAdmin },
      componentEmits: ["delete"],
      clickable: true,
    },
  }));

  const getTableHeaders = () => [
    { name: "Mobilnummer", isSortable: false },
    { name: "Reskortsnummer", isSortable: false },
    { name: "Namn", isSortable: false },
    { name: "Abonnemang", isSortable: false },
    { name: "Köp i appen", isSortable: false },
    { name: "Ta bort", isSortable: false },
  ];

  return {
    ...table,
    getTableHeaders,
  };
};
